// Mask Matrix bundle builder functionality
(function() {
  const dataEl = document.getElementById('mask-matrix-data');
  if (!dataEl) return;
  const data = JSON.parse(dataEl.textContent);
  const randomizeOnLoad = Boolean(data.randomizeOnLoad);

  // Discount config coming from the Liquid JSON
const discountConfig = data.discount || {};

// Line item property keys for the bundle
const BUNDLE_FLAG = '_mask_matrix_bundle';
const BUNDLE_KEY_PROP = '_mask_matrix_bundle_key';
const BUNDLE_DISCOUNT_TYPE_PROP = '_mask_matrix_discount_type';
const BUNDLE_DISCOUNT_VALUE_PROP = '_mask_matrix_discount_value';
const BUNDLE_DISCOUNT_MESSAGE_PROP = '_mask_matrix_discount_message';

  const collections = {};
  data.collections.forEach(col => {
    collections[col.id] = {
      title: col.title,
      handle: col.handle,
      products: [],
      promise: null,
      index: 0
    };
  });

  function fetchCollection(col) {
    if (!col.promise) {
      col.promise = fetch(`/collections/${col.handle}/products.json?limit=250`)
        .then(res => res.json())
        .then(json => {
          col.products = json.products.filter(p =>
            p.variants.some(v => v.available)
          );
          return col.products;
        });
    }
    return col.promise;
  }

  const slots = document.querySelectorAll('.mask-matrix__slot');
  const slotStates = new Map();

  const DRAG_THRESHOLD_RATIO = 0.25;
  const SWIPE_MIN_DISTANCE = 45;
  const DRAG_ACTIVATION_DISTANCE = 10;

  function getAvailableVariants(product) {
    return product?.variants?.filter(variant => variant.available) || [];
  }

  function getAvailableVariant(product) {
    return getAvailableVariants(product)[0] || null;
  }

  function getVariantImageSrc(variant, product) {
    return variant?.featured_image?.src || product?.images?.[0]?.src || '';
  }

  function createSlide(product, variant) {
    const slide = document.createElement('div');
    slide.className = 'mask-matrix__slide';
    const image = document.createElement('img');
    image.className = 'mask-matrix__image';
    image.loading = 'lazy';
    image.draggable = false;
    const src = getVariantImageSrc(variant, product);
    image.src = src;
    image.alt = product?.title || '';
    if (variant?.id) {
      image.dataset.variantId = variant.id;
    } else {
      delete image.dataset.variantId;
    }
    slide.appendChild(image);
    return slide;
  }

  function getViewportWidth(state) {
    const width = state.viewport?.offsetWidth || state.viewport?.getBoundingClientRect?.().width;
    return width || 0;
  }

  function getNeighborInfo(col, direction) {
    const length = col?.products?.length || 0;
    if (length <= 1) return null;
    let index = (col.index + direction + length) % length;
    if (index === col.index) return null;
    const product = col.products[index];
    if (!product) return null;
    const variant = getAvailableVariant(product);
    if (!variant) return null;
    return { index, product, variant };
  }

  slots.forEach(slot => {
    const select = slot.querySelector('.mask-matrix__collection');
    const prev = slot.querySelector('.mask-matrix__prev');
    const next = slot.querySelector('.mask-matrix__next');
    const viewport = slot.querySelector('.mask-matrix__viewport');
    const track = slot.querySelector('.mask-matrix__track');
    const title = slot.querySelector('.mask-matrix__product-title');
    const variantSelect = slot.querySelector('.mask-matrix__variant');

    if (!select || !track || !viewport) {
      return;
    }

    const state = {
      slot,
      select,
      prev,
      next,
      viewport,
      track,
      title,
      variantSelect,
      animating: false,
      drag: null,
      currentProduct: null,
      currentVariant: null,
      currentCollectionId: select.value,
      globalPointerListeners: null
    };

    slotStates.set(slot, state);

    function updateTitle(text) {
      if (title) {
        title.textContent = text || '';
      }
    }

    function updateVariantSelect(product, selectedVariant) {
      if (!variantSelect) return;
      const variants = getAvailableVariants(product);
      if (variants.length <= 1) {
        variantSelect.innerHTML = '';
        variantSelect.hidden = true;
        return;
      }

      variantSelect.hidden = false;
      variantSelect.innerHTML = variants
        .map(variant => {
          const selected = variant.id === selectedVariant?.id ? ' selected' : '';
          return `<option value="${variant.id}"${selected}>${variant.title}</option>`;
        })
        .join('');
    }

    function resetTrack() {
      track.classList.remove('is-animating');
      track.style.transition = 'none';
      track.style.transform = 'translateX(0px)';
    }

    function clearSlot() {
      track.innerHTML = '';
      resetTrack();
      state.animating = false;
      state.drag = null;
      state.currentProduct = null;
      state.currentVariant = null;
      updateTitle('');
      updateVariantSelect(null, null);
    }

    function setCurrentSlide(product, variant) {
      track.innerHTML = '';
      track.appendChild(createSlide(product, variant));
      resetTrack();
      state.animating = false;
      state.drag = null;
      state.currentProduct = product;
      state.currentVariant = variant;
      updateTitle(product?.title);
      updateVariantSelect(product, variant);
    }

    function finishAnimation(product, variant) {
      state.animating = false;
      state.drag = null;
      resetTrack();
      state.currentProduct = product;
      state.currentVariant = variant;
      updateTitle(product?.title);
      updateVariantSelect(product, variant);
    }

    function animateTo(direction, product, variant) {
      if (state.animating) {
        return;
      }
      const width = getViewportWidth(state);
      if (!width || track.children.length === 0) {
        setCurrentSlide(product, variant);
        return;
      }

      state.animating = true;
      const slide = createSlide(product, variant);
      track.classList.remove('is-animating');
      track.style.transition = 'none';

      if (direction > 0) {
        track.appendChild(slide);
        void track.offsetWidth;
        track.classList.add('is-animating');
        track.style.transition = '';
        track.style.transform = `translateX(${-width}px)`;
      } else {
        track.insertBefore(slide, track.firstElementChild);
        track.style.transform = `translateX(${-width}px)`;
        void track.offsetWidth;
        track.classList.add('is-animating');
        track.style.transition = '';
        track.style.transform = 'translateX(0px)';
      }

      const handleTransitionEnd = event => {
        if (event.target !== track) return;
        track.removeEventListener('transitionend', handleTransitionEnd);
        if (direction > 0 && track.firstElementChild) {
          track.removeChild(track.firstElementChild);
        } else if (direction < 0 && track.lastElementChild) {
          track.removeChild(track.lastElementChild);
        }
        finishAnimation(product, variant);
      };

      track.addEventListener('transitionend', handleTransitionEnd);
    }

    function showSlot(col, direction = 0, options = {}) {
      const { immediate = false } = options;
      if (!col || !col.products.length) {
        clearSlot();
        return;
      }

      state.currentCollectionId = col.id || state.currentCollectionId;

      const product = col.products[col.index];
      const variant = getAvailableVariant(product);
      if (!product || !variant) {
        clearSlot();
        return;
      }

      if (direction === 0 || immediate || track.children.length === 0 || col.products.length === 1) {
        setCurrentSlide(product, variant);
      } else if (direction > 0) {
        animateTo(1, product, variant);
      } else if (direction < 0) {
        animateTo(-1, product, variant);
      } else {
        setCurrentSlide(product, variant);
      }
    }

    function loadAndShow(id) {
      const col = collections[id];
      if (!col) {
        clearSlot();
        return;
      }
      state.currentCollectionId = id;
      fetchCollection(col).then(() => {
        if (!col.products.length) {
          clearSlot();
          return;
        }
        col.index = 0;
        showSlot(col, 0, { immediate: true });
      });
    }

    function removeGlobalPointerListeners() {
      const listeners = state.globalPointerListeners;
      if (!listeners) return;
      const { options, move, up, cancel, blur } = listeners;
      window.removeEventListener('pointermove', move, options);
      window.removeEventListener('pointerup', up, options);
      window.removeEventListener('pointercancel', cancel, options);
      window.removeEventListener('blur', blur);
      state.globalPointerListeners = null;
    }

    function addGlobalPointerListeners() {
      if (state.globalPointerListeners) return;
      const options = { capture: true };
      const move = event => handlePointerMove(event);
      const up = event => handlePointerUp(event);
      const cancel = event => handlePointerCancel(event);
      const blur = () => {
        if (state.drag) {
          endDrag({ pointerId: state.drag.pointerId }, true);
        }
      };
      window.addEventListener('pointermove', move, options);
      window.addEventListener('pointerup', up, options);
      window.addEventListener('pointercancel', cancel, options);
      window.addEventListener('blur', blur);
      state.globalPointerListeners = { options, move, up, cancel, blur };
    }

    function handlePrevClick() {
      const col = collections[select.value];
      if (!col || !col.products.length || state.animating || (state.drag && state.drag.dragging)) return;
      col.index = (col.index - 1 + col.products.length) % col.products.length;
      showSlot(col, -1);
    }

    function handleNextClick() {
      const col = collections[select.value];
      if (!col || !col.products.length || state.animating || (state.drag && state.drag.dragging)) return;
      col.index = (col.index + 1) % col.products.length;
      showSlot(col, 1);
    }

    function prepareDrag(dragState, deltaX, deltaY) {
      if (dragState.dragging) return true;
      if (Math.abs(deltaX) < DRAG_ACTIVATION_DISTANCE || Math.abs(deltaX) <= Math.abs(deltaY)) {
        return false;
      }
      const direction = deltaX < 0 ? 1 : -1;
      const neighbor = getNeighborInfo(dragState.collection, direction);
      if (!neighbor) {
        return false;
      }
      const width = getViewportWidth(state);
      if (!width) {
        return false;
      }

      dragState.dragging = true;
      dragState.direction = direction;
      dragState.neighbor = neighbor;
      dragState.width = width;
      dragState.base = direction > 0 ? 0 : -width;
      dragState.deltaX = 0;
      dragState.position = dragState.base;

      state.animating = true;

      const neighborSlide = createSlide(neighbor.product, neighbor.variant);
      dragState.neighborSlide = neighborSlide;

      track.classList.remove('is-animating');
      track.style.transition = 'none';

      if (direction > 0) {
        track.appendChild(neighborSlide);
      } else {
        track.insertBefore(neighborSlide, track.firstElementChild);
        track.style.transform = `translateX(${-width}px)`;
      }

      return true;
    }

    function endDrag(event, cancelled) {
      const dragState = state.drag;
      if (!dragState || event.pointerId !== dragState.pointerId || dragState.ending) {
        return;
      }

      dragState.ending = true;
      removeGlobalPointerListeners();
      state.drag = null;

      if (!dragState.dragging) {
        state.drag = null;
        return;
      }

      const absDelta = Math.abs(dragState.deltaX);
      const threshold = Math.max(dragState.width * DRAG_THRESHOLD_RATIO, SWIPE_MIN_DISTANCE);
      const shouldAdvance = !cancelled && absDelta > threshold;

      if (shouldAdvance) {
        dragState.collection.index = dragState.neighbor.index;
      }

      const targetPosition = shouldAdvance
        ? (dragState.direction > 0 ? -dragState.width : 0)
        : (dragState.direction > 0 ? 0 : -dragState.width);
      const currentPosition = typeof dragState.position === 'number' ? dragState.position : dragState.base;
      const needsTransition = Math.abs(targetPosition - currentPosition) > 0.5;

      const finalize = () => {
        track.classList.remove('is-animating');
        track.style.transition = 'none';
        track.style.transform = 'translateX(0px)';

        if (!shouldAdvance) {
          dragState.collection.index = dragState.originIndex;
          setCurrentSlide(dragState.originProduct, dragState.originVariant);
        } else {
          setCurrentSlide(dragState.neighbor.product, dragState.neighbor.variant);
        }
      };

      if (needsTransition) {
        track.classList.add('is-animating');
        track.style.transition = '';
        void track.offsetWidth;
        track.style.transform = `translateX(${targetPosition}px)`;

        const cleanup = transitionEvent => {
          if (transitionEvent.target !== track) return;
          track.removeEventListener('transitionend', cleanup);
          finalize();
        };

        track.addEventListener('transitionend', cleanup);
      } else {
        finalize();
      }
    }

    function handlePointerDown(event) {
      if (state.animating) return;
      if (event.pointerType === 'mouse' && event.button !== 0) return;

      const col = collections[select.value];
      if (!col || !col.products.length) return;

      state.drag = {
        pointerId: event.pointerId,
        startX: event.clientX,
        startY: event.clientY,
        deltaX: 0,
        deltaY: 0,
        dragging: false,
        ending: false,
        direction: 0,
        neighbor: null,
        neighborSlide: null,
        width: 0,
        base: 0,
        collection: col,
        originIndex: col.index,
        originProduct: state.currentProduct,
        originVariant: state.currentVariant
      };

      addGlobalPointerListeners();
    }

    function handlePointerMove(event) {
      const dragState = state.drag;
      if (!dragState || event.pointerId !== dragState.pointerId || dragState.ending) return;

      const deltaX = event.clientX - dragState.startX;
      const deltaY = event.clientY - dragState.startY;

      if (!prepareDrag(dragState, deltaX, deltaY)) {
        return;
      }

      let limitedDeltaX = deltaX;
      if (dragState.direction > 0) {
        limitedDeltaX = Math.max(deltaX, -dragState.width);
        limitedDeltaX = Math.min(limitedDeltaX, 0);
      } else {
        limitedDeltaX = Math.min(deltaX, dragState.width);
        limitedDeltaX = Math.max(limitedDeltaX, 0);
      }

      dragState.deltaX = limitedDeltaX;
      dragState.deltaY = deltaY;
      const position = dragState.base + limitedDeltaX;
      dragState.position = position;
      track.style.transform = `translateX(${position}px)`;

      event.preventDefault();
    }

    function handlePointerUp(event) {
      if (!state.drag || event.pointerId !== state.drag.pointerId) return;
      endDrag(event, false);
    }

    function handlePointerCancel(event) {
      if (!state.drag || event.pointerId !== state.drag.pointerId) return;
      endDrag(event, true);
    }

    select.addEventListener('change', () => {
      loadAndShow(select.value);
    });

    variantSelect?.addEventListener('change', event => {
      const variantId = Number(event.target.value);
      if (!state.currentProduct) return;
      const variants = getAvailableVariants(state.currentProduct);
      const nextVariant = variants.find(variant => variant.id === variantId);
      if (!nextVariant) return;
      state.currentVariant = nextVariant;
      const img = track.querySelector('.mask-matrix__image');
      if (img) {
        img.dataset.variantId = nextVariant.id;
        const imageSrc = getVariantImageSrc(nextVariant, state.currentProduct);
        if (imageSrc) {
          img.src = imageSrc;
        }
      }
    });

    prev?.addEventListener('click', handlePrevClick);
    next?.addEventListener('click', handleNextClick);

    viewport.addEventListener('pointerdown', handlePointerDown);
    viewport.addEventListener('pointercancel', handlePointerCancel);

    state.showSlot = showSlot;
    state.clearSlot = clearSlot;

    if (!randomizeOnLoad) {
      loadAndShow(select.value);
    }
  });

  const randomizeBtn = document.getElementById('mask-matrix-randomize');
  const addBtn = document.getElementById('mask-matrix-add');

  function randomizeSlots() {
    const ids = Object.keys(collections);
    const fetches = ids.map(id => fetchCollection(collections[id]));
    const usedProductIds = new Set();

    return Promise.all(fetches).then(() => {
      const pool = ids.flatMap(id => {
        const col = collections[id];
        return col.products.map((product, index) => ({ product, col, id, index }));
      });

      slots.forEach(slot => {
        const state = slotStates.get(slot);
        const select = state?.select || slot.querySelector('.mask-matrix__collection');

        let candidates = pool.filter(item => !usedProductIds.has(item.product.id));
        if (!candidates.length) {
          candidates = pool;
        }

        const choice = candidates[Math.floor(Math.random() * (candidates.length || 1))];

        if (!choice) {
          if (select && ids.length) select.value = ids[0];
          state?.clearSlot?.();
          return;
        }

        const variant = getAvailableVariant(choice.product);
        if (!variant) {
          state?.clearSlot?.();
          return;
        }

        usedProductIds.add(choice.product.id);
        if (select) {
          select.value = choice.id;
        }

        if (!state) {
          const img = slot.querySelector('.mask-matrix__image');
          if (img) {
            const imageSrc = choice.product.images?.[0]?.src || '';
            img.src = imageSrc;
            img.alt = choice.product.title;
            if (variant?.id) {
              img.dataset.variantId = variant.id;
            } else {
              delete img.dataset.variantId;
            }
          }
          const titleEl = slot.querySelector('.mask-matrix__product-title');
          if (titleEl) {
            titleEl.textContent = choice.product.title;
          }
          return;
        }

        const col = collections[choice.id];
        if (col) {
          col.index = choice.index;
          if (choice.col && choice.col !== col) {
            choice.col.index = choice.index;
          }
          state.showSlot(col, 0, { immediate: true });
        }
      });
    }).catch(err => {
      console.error('Failed to randomize Mask Matrix products', err);
    });
  }

  randomizeBtn?.addEventListener('click', () => {
    randomizeSlots();
  });

  if (randomizeOnLoad) {
    randomizeSlots();
  }

  addBtn?.addEventListener('click', async (event) => {
    event.preventDefault();

    const bundleItems = new Map();

    // Generate a unique bundle key for this add-to-cart action
    const bundleKey = (
      Date.now().toString(36) +
      Math.random().toString(36).slice(2, 8)
    );

    // Base properties applied to each bundled line
    const baseProperties = {
      [BUNDLE_FLAG]: 'true',
      [BUNDLE_KEY_PROP]: bundleKey
    };

    // Only attach discount properties if configured
    const discountType = (discountConfig.type || 'none').toString();
    const discountValue = Number(discountConfig.value || 0);
    const discountMessage =
      (discountConfig.message && discountConfig.message.toString().trim()) || '';

    if (discountType !== 'none' && discountValue > 0) {
      baseProperties[BUNDLE_DISCOUNT_TYPE_PROP] = discountType;
      baseProperties[BUNDLE_DISCOUNT_VALUE_PROP] = String(discountValue);
    }

    // Always store the configured message if present
    if (discountMessage) {
      baseProperties[BUNDLE_DISCOUNT_MESSAGE_PROP] = discountMessage;
    }

    // Collect the selected variants from the 5 slots
    slots.forEach(slot => {
      const variantSelect = slot.querySelector('.mask-matrix__variant');
      const variantId = variantSelect?.value || slot.querySelector('.mask-matrix__image')?.dataset?.variantId;
      if (!variantId) return;

      const normalizedId = Number(variantId) || variantId;
      const current = bundleItems.get(normalizedId);
      const nextQty = (current?.quantity || 0) + 1;

      bundleItems.set(normalizedId, {
        id: normalizedId,
        quantity: nextQty,
        // clone properties so we don't mutate baseProperties later
        properties: { ...baseProperties }
      });
    });

    const items = Array.from(bundleItems.values());
    if (!items.length) return;

    addBtn.disabled = true;
    try {
      const headers = {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      };

      // Add all bundle lines in one call
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers,
        body: JSON.stringify({ items })
      });

      if (res.ok) {
        // Optionally mark cart as containing a mask-matrix bundle
        try {
          await fetch('/cart/update.js', {
            method: 'POST',
            headers,
            body: JSON.stringify({
              attributes: {
                [BUNDLE_FLAG]: 'true'
              }
            })
          });
        } catch (err) {
          console.error('Failed to set bundle attribute', err);
        }

        if (window.Rebuy?.SmartCart) {
          window.Rebuy.SmartCart.show();
        } else {
          // fallback: take them to cart, if you prefer
          // window.location.href = '/cart';
        }
      } else {
        console.error('Failed to add bundle', await res.text());
      }
    } catch (err) {
      console.error('Failed to add bundle', err);
    } finally {
      addBtn.disabled = false;
    }
  });
})();
